import styled from "styled-components/macro";
import { FormElementProps } from "../helpers";

export const CustomCheckbox = styled.label`
    border-radius: 4px;
    width: ${(props: FormElementProps): number | undefined => props.size}px;
    height: ${(props: FormElementProps): number | undefined => props.size}px;
    margin-bottom: 0;
    background-color: ${(props: FormElementProps): string | undefined => {
        if (props.selected) {
            return props.backgroundColor;
        }

        if (props.disabled) {
            return props.customStyles?.disabledColor;
        }

        if (props.determinate) {
            return props.backgroundColor;
        }

        return "#FFFFFF";
    }};
    border: 2px solid
        ${(props: FormElementProps): string | undefined => {
            if (props.disabled) {
                return "#939598";
            }

            if (props.selected) {
                return props.borderColor;
            }

            if (props.determinate) {
                return props.borderColor;
            }

            return "#707070";
        }};
    opacity: ${(props: FormElementProps): string => {
        if (props.disabled) {
            return `${props.customStyles?.opacity}`;
        }

        return "1";
    }};
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: ${(props: FormElementProps): string => {
        if (props.disabled) {
            return "none";
        }

        return "auto";
    }};

    img {
        width: ${(props: FormElementProps): number | undefined => props.size}px;
        height: ${(props: FormElementProps): number | undefined => props.size}px;
        padding: 3px;
    }

    &:hover {
        border: 2px solid ${(props: FormElementProps): string | undefined => props.hoverColor};
        cursor: pointer;
    }
`;
